import { render } from "./MonitorList.vue?vue&type=template&id=3a0cf43e&ts=true"
import script from "./MonitorList.vue?vue&type=script&lang=ts"
export * from "./MonitorList.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__